export const PDP_URL_PREFIX = 'https://appsumo.com/products/';

export const SUBSCRIBE_URL = '/accounts/signup/email-subscribe/';
export const WAITLIST_URL = '/deal/waitlist-signup/';

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i; // NOSONAR

export const APPSUMO_PLUS_DEAL_ID = 1735;
export const APPSUMO_PLUS_DEAL_PLAN_ID = 130;
export const DEFAULT_PLUS_DISCOUNT_PERCENTAGE = 10;

export const REVIEWS_2_5_UI_EXPERIMENT_NAME = 'reviews-2-5-ui';
export const QUESTIONS_2_5_UI_EXPERIMENT_NAME = 'questions-2-5-ui';
export const CART_SHELF_EXPERIMENT_NAME = 'next-cart-shelf';
export const LOAD_PRIVY_NO_UTM_PARAM = 'privy-no-utm-param';
export const MOBILE_PRIVY_POPUP = 'mobile-privy-popup';
export const EMAIL_ONLY_CHECKOUT_EXPERIMENT_NAME = 'email-only-checkout';
// export const CART_PLUS_UPSELL_EXPERIMENT_NAME = 'cart-plus-upsell'; // variants: ['control', 'body', 'sidebar']
export const PDP_PLUS_SHELF_EXPERIMENT_NAME = 'pdp-plus-shelf'; // variants: ['enabled', 'disabled']
export const SC_ZONE_EXPERIMENT_NAME = 'use-smartcollection-zones'; // variants: ['enabled', 'disabled']
export const CREDITS_COUPONS_EXPERIMENT_NAME = 'checkout-credits-coupons'; // variants: ['enabled', 'disabled']
export const PLUS_MEMBERSHIP_EXPERIMENT_NAME = 'next-plus-membership'; // variants: ['enabled', 'disabled']
export const LEAVE_REVIEW_PAGE_EXPERIMENT_NAME = 'leave-review-page'; // variants: ['enabled', 'disabled']
export const DIRECT_TO_CHECKOUT_EXPERIMENT_NAME = 'direct-to-checkout'; // variants: ['disabled', 'enabled']
export const ASKSUMO_REVIEW_SUMMARY_EXPERIMENT_NAME = 'asksumo-review-summary'; // variants: ['disabled', 'enabled']
export const CHECKOUT_DESKTOP_BUY_EXPERIMENT_NAME = 'checkout-desktop-buy'; // variants: ['disabled', 'enabled']
export const PDP_QR_DEFAULT_TAB_EXPERIMENT_NAME = 'pdp-qr-default-tab'; // variants: ['control', 'reviews']

export const ASKSUMO_COUPON: string = 'SUMOCHAT10';

// Social media share URLs
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?';
export const LINKEDIN_SHARE_URL =
  'https://www.linkedin.com/shareArticle?mini=true&';
export const PLAN_TYPES_SUFFIX = ['annual', 'lifetime'];

export const PDP_REGEX = /\/products\/[a-zA-Z0-9_-]+\/$/;
export const IS_INDEXABLE_PAGE_REGEX =
  /\/products\/[a-zA-Z0-9_-]+\/(reviews|questions)\/[a-zA-Z0-9_-]+\/$/;
export const IS_AGGREGATE_PAGE_REGEX =
  /\/products\/[a-zA-Z0-9_-]+\/(reviews|questions)\/$/;
// strip any query params prior to testing (e.g. had an issue with ?next=/products/...)
export const isPDP = (url: string) => PDP_REGEX.test(url.split('?')?.[0] ?? '');
export const isIndexablePage = (url: string) =>
  IS_INDEXABLE_PAGE_REGEX.test(url);
export const isAggregatePage = (url: string) =>
  IS_AGGREGATE_PAGE_REGEX.test(url);
export enum DEAL_STAGE {
  INACTIVE = 'inactive',
  EARLY_ACCESS = 'early access',
  GENERAL_ACCESS = 'general access',
  LAST_CALL = 'last call',
}
export enum GA4FormContentValue {
  spotlightHome10off = 'spotlight-home-10-off',
  spotlight404Page10Off = 'spotlight-404-page-10-off',
  signUpPdpPricingCardSoldOut = 'sign-up-pdp-pricing-card-sold-out',
  signUpInfoPdpPricingCardInfo = 'sign-up-info-pdp-pricing-card-info',
  alternativeTo10Off = 'alternative-to-10-off',
}
export const CANONICAL_WITH_PAGE_QUERY = [
  '/products/[slug]/questions',
  '/products/[slug]/reviews',
];
export const BIG_BOI_DEFAULT_RGB_BACKGROUND = 'rgb(27, 27, 27)';
